var styles = {"hero":"styles_hero__V7scY relative center","hero-image":"styles_hero-image__uREcr","heroImage":"styles_hero-image__uREcr","overlay":"styles_overlay__3XIvZ bold absolute top-0 left-0 right-0 bottom-0 flex flex-column items-center justify-center"};

export default styles;
//# sourceMappingURL=styles.css.js.map
